/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

import logo from '../../../../assets/images/scalefield_logo.svg';

export const createComponentStyles = makeStyles(theme => ({
  loginSection: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '70px',
  },
  heading: {
    marginBottom: '20px',
  },
  subheading: {
    color: theme.palette.text.primary,
    textAlign: 'center',
    maxWidth: '510px',
  },
  loginImage: {
    maxWidth: '400px',
    marginBottom: '24px',
  },
  logo: {
    backgroundImage: `url('${logo}')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    height: '100px',
    width: '350px',
    marginBottom: '16px',
  },
}));
